import { TypedEventBus } from './EventBus'

export interface AppEvents {
  'booking:queued':      { tempId: string }
  'booking:synced':      { tempId: string; serverDocumentId: string }
  'booking:sync-failed': { tempId: string; error: string }
  'sync:started':        { queueLength: number }
  'sync:completed':      { succeeded: number; failed: number }
}

export const eventBus = new TypedEventBus<AppEvents>()
